import React from 'react';

const DueIcon = (props) => {
    const {size, style} = props;
    return(
        <svg
            fill="#000000" 
            height={size}
            width={size} 
            version="1.1" 
            viewBox="0 0 512 512" 
            enableBackground="new 0 0 512 512"
            style={style}
        >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
            <g id="SVGRepo_iconCarrier"> 
                <g> <g> 
                    <path 
                        d="m294.7,129.7c19.2-23.1 32.1-74.5 37.7-99.9l4.2-18.8-70.1,30.2c-6.3,2.1-12.5,1-17.8-2.1-11.5-7.3-25.1-8.3-37.6-3.1l-37.6,16.7c-8.4,4.2-14.6,11.5-16.7,20.9-1,9.4 1,18.8 7.3,26.1 11.7,12.9 30.4,25.8 44.1,34.5-66.4,35.1-112.2,136.8-112.2,207.3 0,87.6 72.2,159.5 160,159.5 88.9,0 160-71.9 160-159.5 0-73.8-50.2-181.6-121.3-211.8zm-115-42.6c-2.1-2.1-3.1-5.2-2.1-8.3 0-2.1 2.1-5.2 5.2-6.3l37.6-16.7c5.2-3.1 12.5-2.1 17.8,1 10.5,7.3 24.1,8.3 36.6,3.1l33.5-14.6c-10.5,40.7-25.1,75.1-33.5,76.1v1.9c-6.2-1.3-12.4-1.9-18.8-1.9-8.6,0-17.1,1.2-25.3,3.5-11.2-6.3-37.2-22.3-51-37.8zm76.3,394.1c-77.4-5.68434e-14-140.1-62.6-140.1-139.7 0-77.1 63.8-200.2 140.1-200.2s140.1,123 140.1,200.2c0,77.1-62.7,139.7-140.1,139.7z"></path> <path d="m299.9,312.3c-6.3-6.3-17.8-11.5-33.5-14.6h-1v-38.6c9.4,1 19.9,5.2 28.2,11.5l12.5-18.8c-13.6-8.3-27.2-13.6-41.8-14.6v-10.4h-12.5v10.4c-12.5,1-23,5.2-31.4,12.5-8.4,7.3-12.5,16.7-12.5,28.1s3.1,19.8 10.5,26.1c7.3,6.3 18.8,11.5 33.5,14.6v39.6c-11.5-2.1-23-8.3-34.5-17.7l-14.6,17.7c14.6,12.5 30.3,19.8 49.2,21.9v14.6h13.6v-14.6c13.6-1 24.1-5.2 32.4-12.5s12.5-16.7 12.5-28.1c-0.1-12.5-3.3-20.8-10.6-27.1zm-47-17.7c-8.4-2.1-12.5-4.2-15.7-7.3-3.1-2.1-4.2-6.3-4.2-10.4 0-5.2 2.1-8.3 5.2-11.5 3.1-3.1 7.3-5.2 14.6-5.2v34.4zm27.3,58.4c-4.2,3.1-8.4,5.2-15.7,6.3v-36.5c8.4,2.1 13.6,4.2 16.7,7.3 3.1,3.1 4.2,7.3 4.2,11.5 0,4.1-1.1,8.2-5.2,11.4z"
                    >
                    </path> 
                </g> </g> 
            </g>
        </svg>
    )
}

export default DueIcon;